import axios from 'axios';
import * as Sentry from '@sentry/react';
import { gql } from '@apollo/client';
import { getStore } from 'spw-redux/store-registry';
import { AuthFlowType } from 'spw-redux/modules/auth/types';
import { graphqlClient } from './utils';

const apiCall = axios.create({
  baseURL: '/',
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json',
  },
  transformRequest: (data, headers) => {
    let csfrToken;
    if (getStore()) {
      ({ csfrToken } = getStore()?.getState()?.authReducer);
    }
    // eslint-disable-next-line no-param-reassign
    headers['x-csrf-token'] = csfrToken;
    return JSON.stringify(data);
  },
});

export const beginAuth = (email: string) =>
  graphqlClient.query<{ flow: { type: AuthFlowType; redirectUrl: string } }>({
    fetchPolicy: 'no-cache',
    query: gql`
      query AuthenticationFlow($email: String) {
        flow: authenticationFlow(email: $email) {
          redirectUrl
          type
        }
      }
    `,
    variables: {
      email,
    },
  });

export const login = (username: string, password: string) => {
  let timezone = 'America/Los_Angeles';
  try {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (e) {
    Sentry.captureException(e);
    // try/catch because Intl.DateTimeFormat isn't supported in some older browsers
  }

  return apiCall({
    method: 'post',
    url: '/auth/identity/callback',
    data: {
      username,
      password,
      timezone,
    },
  });
};

export const logout = () =>
  apiCall({
    method: 'get',
    url: '/auth/logout',
  });

export const sendRecoveryEmail = ({
  email,
  token,
}: {
  email?: string;
  token?: string;
}) =>
  apiCall({
    method: 'post',
    url: '/auth/password-reset',
    data: {
      email,
      token,
    },
  });

export const sendVerifyPassword = (
  token: string,
  newPassword: string,
  verifyPassword: string
) =>
  apiCall({
    method: 'post',
    url: '/auth/update-password',
    data: {
      token,
      newPassword,
      verifyPassword,
    },
  });
